import _omit from 'lodash/omit';

import { isString } from 'lodash';
import { ITournamentBanner, ITournamentBannerRow, LOCATION_IMAGE_RATIO_MAP } from './constants';

const hydrateFormData = (data: ITournamentBannerRow, propToOmit: string[]): ITournamentBanner => {
	const { ctaValue, ctaType, ctaParamsGameName } = data;
	const hydratedData: ITournamentBanner = {
		..._omit(data, propToOmit),
		cta: {
			type: ctaType,
			value: ctaValue,
			params: {
				gameName: isString(ctaParamsGameName) ? ctaParamsGameName.toUpperCase() : ctaParamsGameName
			}
		}
	} as ITournamentBanner;

	return hydratedData;
};

export const hydrateCreateFormData = (data: ITournamentBannerRow): ITournamentBanner => {
	return hydrateFormData(data, ['ctaValue', 'ctaType', 'ctaParamsGameName', 'index', 'language']);
};

export const hydrateEditFormData = (data: ITournamentBannerRow): ITournamentBanner => {
	return hydrateFormData(data, ['ctaValue', 'ctaType', 'ctaParamsGameName']);
};

export const dehydrateFormData = (formData: any): ITournamentBanner => {
	const lobbyBannerData = {
		...formData,
		imageRatio: LOCATION_IMAGE_RATIO_MAP.HOME_SCREEN.toString()
	};

	delete lobbyBannerData.index;
	delete lobbyBannerData.language;

	return lobbyBannerData;
};
